<template>
  <v-app id="inspire" >
    <v-content class="content">
      <v-container
        fluid
      >
        <v-row
          align="start"
          justify="center"
          class="pa-0"
        >
          <v-col
            cols="10"
            sm="6"
            md="5"
            lg="4"
            xl="4"
            class="pa-0 mt-0"
          >
            <ErrorSnackbar :errorMessage="this.authErrors.errorMessage" :errorSnackbar.sync="errorSnackbar"/>
            <div class = "title-container">
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class="headline mb-1">
                    <v-icon id="icon-style" size="2.4vh">fas fa-clouds</v-icon>
                  </v-list-item-title>
                  <v-list-item-subtitle class ="icon-subtitle">multicloud</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item >
                <v-list-item-content class="ma-0 pa-0">
                  <v-list-item-title class ="login-title ma-0 pa-0">Sign Up</v-list-item-title>
                  <v-list-item-subtitle class="ma-0 pa-0">
                    <hr class="underscore">
                  </v-list-item-subtitle>
                  <p class="login-subtitle">PSC Multicloud Platform</p>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-form @submit.prevent="onSignup">
              <v-card class="elevation-0 pl-2 pr-2 pb-0 pt-0 ma-0" color="rgba(255, 0, 0, 0)">
                <v-card-text class="justify-center pr-2 pl-2 pb-0 pt-0">
                    <v-text-field
                      class="email"
                      :class="{'email': !errors && $v.credentials.email.required && $v.credentials.email.email,
                      'email-error': errors && !$v.credentials.email.required || !$v.credentials.email.email}"
                      name="email"
                      type="text"
                      placeholder="Email"
                      rounded
                      solo
                      hide-details
                      flat
                      height="50px"
                      v-model="credentials.email"
                      :error="errors && !$v.credentials.email.required || !$v.credentials.email.email"
                    ></v-text-field>
                    <v-text-field
                      class="password"
                      :class="{'password': !errors && $v.credentials.password.required,
                      'password-error': errors && !$v.credentials.password.required }"
                      name="password"
                      type="password"
                      placeholder="Password"
                      rounded
                      solo
                      flat
                      hide-details
                      height="50px"
                      v-model="credentials.password"
                      :error="errors && !$v.credentials.password.required"
                    >
                     <v-tooltip slot="append" max-width="16vw" right>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">
                            fas fa-question
                        </v-icon>
                      </template>
                      <span>Your password must:</span>
                      <ul>
                        <li>have at least 8 characters</li>
                        <li>contain at least one uppercase letter</li>
                        <li>contain at least one number digit</li>
                        <li>contain at least one special character</li>
                      </ul>
                      </v-tooltip>
                    </v-text-field>
                    <v-text-field
                      class="confirm-password"
                      :class="{'confirm-password': !errors && $v.credentials.confirmPassword.required && $v.credentials.confirmPassword.sameAsPassword,
                      'confirm-password-error': errors && !$v.credentials.confirmPassword.required || !$v.credentials.confirmPassword.sameAsPassword}"  
                      name="confirmPassword"
                      type="password"
                      placeholder="Confirm Password"
                      :error-messages="!$v.credentials.confirmPassword.sameAsPassword && !loading ? 'The passwords you entered do not match' : null"
                      rounded
                      solo
                      flat
                      height="50px"
                      v-model="credentials.confirmPassword"
                      :error="errors && !$v.credentials.confirmPassword.sameAsPassword"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center mt-0 pt-0">
                  <v-btn
                    id="signup"
                    class="text-none mb-0 pb-0"
                    type="submit" 
                    rounded
                    min-height="50px"
                    height="50px"
                    max-height="50px"
                    :disabled="errors || $v.credentials.$invalid"
                  >
                  <v-icon id="spinner" medium center v-if="loading">fas fa-spinner fa-spin</v-icon>
                  <span v-else>Sign Up</span>
                  </v-btn>
                </v-card-actions>
                <v-card-text class="text-center">
                  <p class="create-account-text">Already have an account? </p>
                  <a class="create-account-link" @click="signinRedirect()">Log In</a>
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import ErrorSnackbar from "./ErrorSnackbar";

import { required, email, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      credentials: {
        email: "",
        password: "",
        confirmPassword: ""
      },
      errors: false,
      errorSnackbar: false,
      loading: false
    };
  },
  mixins: [validationMixin],
  computed: mapGetters(["cognitoInfo", "authErrors"]),
  validations: {
    credentials: {
      email: { required, email },
      password: { required },
      confirmPassword: { sameAsPassword: sameAs("password") }
    }
  },
  methods: {
    ...mapActions(["signup"]),
    async onSignup() {
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.loading = true;
        const credentials = {
          password: this.credentials.password,
          username: this.credentials.email.toLowerCase()
        };

        
        this.clearData();

        await this.signup(credentials);
        
        if (this.authErrors.isError) this.errorSnackbar = true;
        if (this.cognitoInfo.username) {
          this.$router.push("/signup/verify");
        }

        this.loading = false;
      }
    },
    signinRedirect() {
      this.$router.push("/login");
    },
    clearData() {
      this.credentials = {
        password: '',
        username: '',
        confirmPassword: ''
      };
    }
  },
  components: {
    ErrorSnackbar
  }
};
</script>

<style scoped>
.content {
  background-image: url("../../assets/casestudies-banner.png");
  background-size: cover;
}

.password .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

.confirm-password .v-input__slot {
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

.email .v-input__slot{
  background-color: #ffffff;
  font: 1.2rem "Montserrat";
}

#signup {
  background-color: #6db42c;
  color: #ffffff !important;
  width: 100%;
  font: 1.2rem "Montserrat";
  transition: all .2s ease;
  border-radius: 12vw;
}

#signup:focus::before {
  opacity: 0 !important;
}

.title-container {
  text-align: center;
  margin-bottom: 6.5vh;
  margin-top: 2vh!important;
}

#icon-style {
  color: #ffffff !important;
  margin-top: 0.3vh!important;
}

.icon-subtitle {
  color: #ffffff !important;
  margin-bottom: 8vh;
  font: bold 1rem "Montserrat";
}

.login-title {
  color: #ffffff !important;
  font: Bold 2.3rem "Montserrat";
}

.login-subtitle {
  color: #ffffff !important;
  font: 1rem "Montserrat";
}

.underscore {
  background-color: #6db42c;
  border: 0.2vh solid #6db42c;
  border-radius: 0.2vh;
  width: 3vw;
  margin: auto;
  margin-top: 1.6vh;
  margin-bottom: 3vh;
}

.create-account-text {
  color: #ffffff;
  display: inline;
  font: 1rem "Montserrat";
  letter-spacing: 0.1vw;
}

a.create-account-link {
  color: #6db42c;
  font: bold 1rem "Montserrat";
  letter-spacing: 0.1vw;
  text-decoration: none;
}

a.create-account-link:hover {
  text-decoration: underline;
}

#spinner {
  color: white!important;
}

.email >>> .v-input__control{
    min-height: auto !important;
    border-radius: 12vw!important;
    margin-bottom: 4%;
    font: 1rem "Montserrat";
}

.password >>> .v-input__control{
    min-height: auto !important;
    border-radius: 12vw!important;
    margin-bottom: 4%;
    font: 1rem "Montserrat";
}

.confirm-password >>> .v-input__control{
    min-height: auto !important;
    border-radius: 12vw!important;
    margin-bottom: 3%;
    font: 1rem "Montserrat";
}
</style>